import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import {
  ActionIcon,
  ActionSection,
  EditItemIcon,
  ListItem,
  Section,
} from './styles';
import Icon from 'components/Icon';
import { withTitle } from '../../withTitle';
import { IReportView } from 'store/survey/surveyTypes';
import LocalIcon from '../../../ui/LocalIcon';
import { black } from '../../../utils/style/colors';
import i18n from '../../../i18n';

interface IComponentProps {
  canUpdate: boolean;
  index?: number;
  isReportItem: boolean;
  onChooseAReport: (
    reportId: number,
    type: 'analyse' | 'edit' | 'pureValue'
  ) => void;
  onCopyReport?: (reportId: number) => void;
  onDeleteReport?: (reportId: number) => void;
  onOpenCheckPoints?: () => void;
  report: IReportView;
  selectedReport: number | null;
  onAddRemoveReport?: (reportId: number) => void;
  oldVersion?: boolean;
  deleteReportList?: number[];
}

class SavedReportItem extends React.PureComponent<IComponentProps> {
  onAnalyse = (e: React.MouseEvent) => {
    e.preventDefault();
    if (
      (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) &&
      this.props.onAddRemoveReport
    ) {
      this.props.onAddRemoveReport(this.props.report.id);
    } else {
      e.stopPropagation();
      this.props.onChooseAReport(this.props.report.id, 'analyse');
    }
  };

  onEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    this.props.onChooseAReport(this.props.report.id, 'edit');
  };
  onChoosePureValue = (e: React.MouseEvent) => {
    e.stopPropagation();
    this.props.onChooseAReport(this.props.report.id, 'pureValue');
  };

  onCopyReport = (e: React.MouseEvent) => {
    e.stopPropagation();
    this.props.onCopyReport?.(this.props.report.id);
  };

  onDeleteReport = (e: React.MouseEvent) => {
    e.stopPropagation();
    const confirmed = window.confirm(
      i18n.t('confirmDeleteAReport', { ns: 'survey' })
    );
    if (confirmed) {
      this.props.onDeleteReport?.(this.props.report.id);
    }
  };

  onOpenCheckPoints = (e: React.MouseEvent) => {
    e.stopPropagation();
    this.props.onOpenCheckPoints?.();
  };

  render() {
    const {
      index,
      report,
      selectedReport,
      canUpdate,
      isReportItem,
      oldVersion,
    } = this.props;

    const isItemSelectedToDelete = this.props.deleteReportList?.includes(
      this.props.report.id
    );

    const percentageList = [
      'percentageOfCount',
      'percentageOfAvg',
      'percentageOfTotalAvg',
    ];

    return (
      <Draggable
        draggableId={report.id.toString()}
        index={index || 0}
        isDragDisabled={!canUpdate}
      >
        {(provided) => {
          const isPercentage = percentageList.includes(
            report?.series?.[0].metric
          );
          return (
            <ListItem
              onClick={this.onAnalyse}
              onContextMenu={this.onAnalyse}
              isSelectedToDelete={isItemSelectedToDelete}
              isActive={selectedReport === report.id}
              ref={provided.innerRef}
              {...provided.draggableProps}
            >
              <Section>
                <span
                  style={{
                    height: '100%',
                    width: '1.5rem',
                    opacity: canUpdate ? 1 : 0,
                  }}
                  {...provided.dragHandleProps}
                >
                  <i className="drag-icon mx-0" />
                </span>
                <span
                  style={{
                    margin: '5px 3px',
                    height: '100%',
                  }}
                >
                  {report.name}
                </span>
              </Section>
              {
                <ActionSection>
                  {canUpdate && !oldVersion && this.props.onDeleteReport && (
                    <ActionIcon onClick={this.onDeleteReport}>
                      <LocalIcon
                        iconName="trash.svg"
                        type="sm"
                        color={black}
                        style={{ margin: 'auto 0', height: '100%' }}
                        title={i18n.t('deleteAReport', { ns: 'survey' })}
                      />
                    </ActionIcon>
                  )}
                  {canUpdate &&
                    !oldVersion &&
                    ((this.props.onCopyReport && !isReportItem) ||
                      (isReportItem && !report.surveyId)) &&
                    !(report.type === 'task') &&
                    !oldVersion && (
                      <ActionIcon onClick={this.onCopyReport}>
                        <LocalIcon
                          iconName="duplicate.svg"
                          type="sm"
                          color={black}
                          style={{ margin: 'auto 0', height: '100%' }}
                          title={i18n.t('copyAReport', { ns: 'survey' })}
                        />
                      </ActionIcon>
                    )}
                  {!(report.type === 'task') &&
                    this.props.onOpenCheckPoints && (
                      <ActionIcon onClick={this.onOpenCheckPoints}>
                        <LocalIcon
                          iconName="target.svg"
                          type="sm"
                          color={black}
                          style={{ margin: 'auto 0', height: '100%' }}
                          title={i18n.t('targets', { ns: 'survey' })}
                        />
                      </ActionIcon>
                    )}
                  {!this.props.onCopyReport &&
                    isPercentage &&
                    withTitle(
                      <ActionIcon onClick={this.onChoosePureValue}>
                        {i18n.t('numbers', { ns: 'survey' })}
                      </ActionIcon>,
                      i18n.t('amountInstedOfPercent', { ns: 'survey' }),
                      'top'
                    )}
                </ActionSection>
              }
              {this.props.onCopyReport
                ? !oldVersion && (
                    <Section>
                      <EditItemIcon
                        isActive={selectedReport === report.id}
                        onClick={this.onEdit}
                      >
                        <LocalIcon
                          iconName="edit.svg"
                          type="sm"
                          color={black}
                          style={{ margin: 'auto 0', height: '100%' }}
                          title={i18n.t('editAReport', { ns: 'survey' })}
                        />
                      </EditItemIcon>
                    </Section>
                  )
                : isPercentage && (
                    <Section>
                      <EditItemIcon isActive={selectedReport === report.id}>
                        <Icon type="percent" />
                      </EditItemIcon>
                    </Section>
                  )}
            </ListItem>
          );
        }}
      </Draggable>
    );
  }
}

export default SavedReportItem;
